<vi-panel>
  <div content>
    <div
      class="filter-header flex gt-sm:flex-row lt-md:flex-col gap-[24px] lt-md:gap-[16px] justify-between items-center"
    >
      <div
        class="flex gt-xs:flex-row xs:flex-colgap-[24px] xs:justify-center xs:items-center gt-xs:justify-center gt-xs:items-baseline"
      >
        <app-chip-filters>
          <app-chip-filter
            data-at-filter-all-subscriptions
            [active]="activeSubscriptionsFilter === subscriptionsFilterType.ALL"
            gtm="onSetFilter"
            gtmAction="Pro & Plus"
            gtmCategory="userDetails"
            (click)="setFilter(subscriptionsFilterType.ALL)"
            >{{ '+BOOKING.OVERVIEW.FILTER.ALL' | translate }}</app-chip-filter
          >
          <app-chip-filter
            data-at-filter-pro-subscriptions
            [active]="activeSubscriptionsFilter === subscriptionsFilterType.PRO"
            gtm="onSetFilter"
            gtmAction="Pro"
            gtmCategory="userDetails"
            (click)="setFilter(subscriptionsFilterType.PRO)"
            >{{ '+BOOKING.OVERVIEW.FILTER.PRO' | translate }}</app-chip-filter
          >
          <app-chip-filter
            data-at-filter-plus-subscriptions
            [active]="activeSubscriptionsFilter === subscriptionsFilterType.PLUS"
            gtm="onSetFilter"
            gtmAction="Plus"
            gtmCategory="userDetails"
            (click)="setFilter(subscriptionsFilterType.PLUS)"
            >{{ '+BOOKING.OVERVIEW.FILTER.PLUS' | translate }}</app-chip-filter
          >
        </app-chip-filters>
        <mat-checkbox
          #includeExpiredCheckbox
          gtm="onToggle"
          gtmAction="Include expired bookings"
          gtmCategory="userDetails"
          >{{ '+USER_DETAILS.BOOKINGS.FILTER.EXPIRED_BOOKINGS' | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</vi-panel>
<div class="list-item-wrapper !flex flex-col justify-start items-start">
  <div
    class="list-item-header !flex flex-row justify-start items-center"
    [class.with-scrollbar]="subscriptions.length > 7"
  >
    <div class="package flex-[7%] max-w-[7%]">
      {{ '+USER_DETAILS.BOOKINGS.PACKAGE' | translate }}
    </div>
    <div class="status flex-[6%] max-w-[6%]">
      {{ '+USER_DETAILS.BOOKINGS.Status' | translate }}
    </div>
    <div class="device flex-[20%] max-w-[20%]">
      {{ '+USER_DETAILS.BOOKINGS.DEVICE' | translate }}
    </div>
    <div class="owner flex-[25%] max-w-[25%]">
      {{ '+USER_DETAILS.BOOKINGS.OWNER' | translate }}
    </div>
    <div class="details flex-[35%] max-w-[35%]">
      {{ '+USER_DETAILS.BOOKINGS.BOOKINGS_DETAILS' | translate }}
    </div>
  </div>
  <div class="installations-wrapper">
    <app-package-per-installation-row
      class="!flex flex-row"
      *ngFor="
        let subscription of subscriptions
          | sortBookings
            : {
                filter: activeSubscriptionsFilter,
                includeExpiredSubscriptions: includeExpiredCheckbox.checked
              }
      "
      [subscription]="subscription"
    ></app-package-per-installation-row>
  </div>
</div>
